import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react'

import queryString from 'query-string'

import { useSelector, useDispatch } from 'react-redux'

import { withRouter } from 'react-router-dom'

import {
  setSettingsModal, setPrinterModal, setExportModal,
  setPrintCaptures, setShareModal, setCaptureSelections, setAllChecked,
  setFilter, setSearchModal, setFilterModal, setReportsModal,
  // setSelectedViolationId, setPageChanged,
  setMySchoolsModal
} from '../redux/actions/select'

import {
  PrintCapturesPreview, ExportCaptures,
  NavButtonContainer, SearchResultsUI, FilterSlideout, TablePagination,
  MySchoolsModal, ReportsModal, NavbarComponent
} from '../components/ui'

import SettingsScreen from '../components/ui/modals/newSettings'

import FilterTour from '../components/ui/modals/FilterTour'

import ShareCard from '../components/ui/modals/newShareCard'

import Flagger from '../components/ui/tools/Flag'
import ElevioIntegration from '../components/ui/tools/Elevio'

import ReportsButtonContainer from '../components/ui/tools/ReportsButtonContainer'

import { NotificationToast } from '../components/ui/tools'

import InteractiveButton from '../components/ui/tools/newInteractiveButton'

import { shareViolation, setViolationStatus, getViolations, searchViolations, setViolations } from '../redux/actions/violations'

import {
  getHistory, getComments, getAvailableUsers, setStatusSnack, setTriggerFilter, setPageType, initiateLearnsafe,
  getUserFilters
  // postHistory
} from '../redux/actions'

import { handleError, Toast, keyify2, getViolationIndex } from '../utils'
import { statusFilterDetails } from '../utils/variables'

import Grid from '@material-ui/core/Grid'

import log from 'loglevel'
import moment from 'moment'

// import { refreshToken, inactivityLogout } from '../redux/actions/auth'
// import { getSettings } from '../redux/actions/settings'

const CapturePageBody = props => {
  const { fromLink, from = {}, fetchCaptures = true } = props
  const dispatch = useDispatch()
  // const classes = useStyles()

  const currentPath = props.location.pathname.replace(/\//g, '')

  // ref variable to ensure captures are only fetched when necessary
  const refreshCapturesRef = useRef(true)

  // ref to prevent to many api calls to fetch user filters
  const userFilterFetch = useRef(true)

  const {
    PrintCaptures, PageCaptureLimit, Filter, PageType: pageType,
    SettingsModal, ReportsModal: ReportsModalState, CaptureModal, PrinterModal, ExportModal, ShareModal, SearchModal, FilterModal,
    MySchoolsModal: SchoolsModal, StatusSnack: SnackShow, AwaitTrigger
  } = useSelector(state => state.selection)

  const { violations: { hits: Hits = 0, captures: Captures = [] } = {} } = useSelector(state => state.violations)
  const { unitTree: TreeData = [] } = useSelector(state => state.auth)
  const DefaultView = useSelector(state => state.userSettings.general.defaultView)
  const userFilters = useSelector(state => state.filters.filters)

  // const defaultReportSet = useSelector(state => state.selection.defaultReportSet)
  // stores the prior url from navigation history in the captures view
  // const defaultReport = useSelector(state => state.userSettings.general.defaultReport)

  const [parsedProps, setParsedProps] = useState({ view: '', page: 0, captureTrgts: null })

  const [searchOpen, setSearchOpen] = useState(false)
  const [SelectedStatus, setSelectedStatus] = useState('A')

  useMemo(() => {
    if (props.location && Boolean(props.location.search) && typeof PageCaptureLimit === 'number') {
      try {
        const searchProps = queryString.parse(props.location.search)

        if (searchProps && typeof searchProps === 'object' && Boolean(searchProps.view)) {
          // !!TO DO: This logic is duplicated numerous times in various files. Need to move to util or move this memo to a parent component of all files in which it is used.
          const captureTrgts = (() => {
            switch (searchProps.view) {
              case 'single': {
                try {
                  // capture (singular) returns a number string, with a 1 based index
                  return parseInt(searchProps.capture) || null
                } catch (err) {
                  return null
                }
              }
              case 'grid': {
                try {
                  // active captures (plural) in grid view returns an array (considered truthy even when empty so the following logic will work as expected)
                  return JSON.parse(searchProps.activeCaptures) || null
                } catch (err) {
                  return null
                }
              }
              case 'list': {
                try {
                  // active capture (singular) in list view returns a number string, with a 0 based index.
                  // Previously this used the same logic as the 'single' case. However as it was 0 based, the `parseInt(searchProps.activeCapture) || null` always returned null at the first index as 0 is falsey
                  const parsedCaptureNum = parseInt(searchProps.activeCapture)
                  if (!isNaN(parsedCaptureNum)) {
                    return parsedCaptureNum
                  } else {
                    return null
                  }
                } catch (err) {
                  return null
                }
              }
              default: return null
            }
          })()

          const page = (() => {
            if (searchProps.view === 'single' && typeof captureTrgts === 'number') { return Math.floor((captureTrgts - 1) / PageCaptureLimit) + 1 }
            return parseInt(searchProps.page) || 0
          })()

          setParsedProps({ view: searchProps.view, page, captureTrgts })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }, [props.location, PageCaptureLimit])

  // fetch the user's filters on load
  useMemo(() => {
    if (userFilterFetch.current && !userFilters.length) {
      userFilterFetch.current = false
      dispatch(getUserFilters())
    }
  }, [dispatch, userFilters])

  // fetch violation on pagination change
  useMemo(() => {
    const fireViolationFailure = (err = '') => {
      log.error(err)
      Toast.fire({
        icon: 'error',
        title: 'Error fetching initial capture list.'
      })
    }

    // Base capture fetch; based on changing filter
    if (
      refreshCapturesRef.current && fetchCaptures && !fromLink && dispatch && Filter != null && PageCaptureLimit != null && Boolean(parsedProps.view)
    ) {
      console.warn('refresh state currently set to true')
      dispatch(getViolations(Filter, PageCaptureLimit, parsedProps.page - 1, fireViolationFailure))
    } else if (!refreshCapturesRef.current) {
      refreshCapturesRef.current = true
      console.warn('refresh state currently set to false')
    }
  }, [fetchCaptures, dispatch, Filter, parsedProps.view, parsedProps.page, PageCaptureLimit, fromLink])

  // if the filter doesn't have an end date, set one to prevent new captures on pagination
  useMemo(() => {
    if (!fromLink && !Filter.endDate) {
      log.warn('setting new end date')
      const now = moment().unix() * 1000
      // console.log(now * 1000)
      dispatch(setFilter({ ...Filter, endDate: now }))
    } else {
      log.warn(Filter.endDate)
    }
  }, [fromLink, Filter, dispatch])

  // Get the list of captures associated with a link share
  useMemo(() => {
    const fireViolationFailure = (err = '') => {
      log.error(err)
      Toast.fire({
        icon: 'error',
        title: 'Error fetching initial capture list.'
      })
    }

    if (
      fromLink && from.location && from.location.pathname && from.location.pathname === '/captures' &&
      dispatch && Filter != null
    ) {
      dispatch(getViolations(Filter, 100, 0, fireViolationFailure))
    }
  }, [dispatch, Filter, from.location, fromLink])

  useEffect(() => {
    dispatch(initiateLearnsafe(() => { }, () => { NotificationToast(true, 'Failed to initiate LearnSafe!') }))
  }, [dispatch])

  const handleShare = async (capture) => {
    try {
      dispatch(shareViolation(capture))
    } catch (err) {
      handleError(err)
    }
  }

  // If the previous page comes from the capture view and was not single view, then return to the previous spot
  useMemo(() => {
    if (from.location && from.location.pathname && from.location.pathname === '/captures' && from.location.search && !from.location.search.includes('?view=single')) {
      dispatch({
        type: 'SET_FROM_URL',
        payload: {
          pathname: from.location.pathname,
          search: from.location.search
        }
      })
    }
  }, [from.location, dispatch])

  const handleSort = (e) => {
    const sort = e.target.id
    const filter = { ...Filter, sort, refresh: true }
    dispatch(setFilter(filter))
  }

  const handleSearchSelection = async (filter) => {
    dispatch(setSearchModal(true))
    dispatch(setFilter(filter))
  }

  const handleRefresh = async () => {
    let runtimeError = false
    await dispatch(setCaptureSelections([]))
      .catch(err => {
        Toast.fire({
          icon: 'error',
          title: 'Error fetching capture list.'
        })

        log.error(err)
        runtimeError = true
      })

    if (!runtimeError) {
      Toast.fire({
        icon: 'success',
        title: 'List updated successfully!'
      })
    }

    if (parsedProps.view === 'grid') {
      props.history.push({
        pathname: '/captures',
        search: `?view=grid&page=${parsedProps.page}&activeCaptures=[]`
      })
    }
    if (!Filter.startDate || Filter.startDate === null || !Filter.endDate) {
      log.warn('no end date. setting one now')
      // if we don't have a range of times, or if there's no end date, set one
      const now = moment().unix() * 1000
      // console.log(now * 1000)
      dispatch(setFilter({ ...Filter, includeViolationIDs: [], endDate: now }))
    } else {
      log.warn('sticking with the filter we\'ve got')
      // if we already have a range, stick with what we've got
      const filter = { ...Filter, includeViolationIDs: [], refresh: true }
      dispatch(setFilter(filter))
    }
  }

  const toggleFilterModal = () => {
    dispatch(setFilterModal(true))
  }

  const handleSearch = async (text) => {
    dispatch(setSearchModal(true))
    const filter = {
      phrase: text
    }
    await dispatch(searchViolations(filter))
      .catch(err => handleError(err))
  }

  // Updates selected capture status when status button is clicked
  const clickStatus = async (status, sharedArray = []) => {
    const Status = Filter.captureAreas
    let statusName = ''
    if (Status?.length) {
      statusName = statusFilterDetails.find(obj => obj.statusValue === Status[0])?.statusLabel || ''
    }
    switch (parsedProps.view) {
      case 'grid': {
        if (Array.isArray(parsedProps.captureTrgts) && Boolean(parsedProps.captureTrgts.length)) {
          // calculate indices based on pagination count
          const violations = (() => {
            if (sharedArray.length) {
              return sharedArray
            }

            return parsedProps.captureTrgts.reduce((arr, captureNum) => {
              if (typeof captureNum === 'number') {
                const captureIx = getViolationIndex({ captureNum, pageLimit: PageCaptureLimit, currentView: parsedProps.view, page: parsedProps.page })
                const captureInfo = (() => {
                  if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
                  return {}
                })()

                if (captureInfo && Boolean(captureInfo.violationID)) { arr.push(captureInfo.violationID) }
              }

              return arr
            }, [])
          })()

          const hasUpdated = await runViolationUpdate(status, violations)
          if (!hasUpdated) {
            Toast.fire({
              icon: 'error',
              title: 'Failed to update violations!'
            })
          } else {
            Toast.fire({
              icon: 'success',
              title: 'Violations updated successfully!'
            })
            dispatch(setAllChecked(false))
            // update the violations included in the filter, but don't re-fetch yet
            if (Filter.captureAreas.length > 0) {
              const violationIDs = [...Filter.includeViolationIDs]
              violations.forEach((id) => {
                const idx = violationIDs.indexOf(id)
                if (idx === -1) {
                  violationIDs.push(id)
                }
              })
              refreshCapturesRef.current = false
              dispatch(setFilter({ ...Filter, includeViolationIDs: violationIDs, refresh: false }))
            } else {
              refreshCapturesRef.current = false
              dispatch(setFilter({ ...Filter, includeViolationIDs: [], refresh: false }))
            }
            return props.history.push({
              pathname: '/captures',
              search: `?view=grid&page=${parsedProps.page}&activeCaptures=[]`
            })
          }
          // if there is only one capture left and we're on the last page, show a message
          // if (SelectedViolationKeyNumber && Hits && SelectedViolationKeyNumber >= Hits) {
          //   Toast.fire({
          //     icon: 'info',
          //     title: `No more captures available with the status '${setStatus()}'.`
          //   })
          // }
          break
        } else {
          Toast.fire({
            icon: 'info',
            title: 'Please select one or more captures.'
          })
          break
        }
      }
      case 'single': {
        dispatch(setStatusSnack(false))

        const captureIx = getViolationIndex({ page: parsedProps.page, currentView: parsedProps.view, pageLimit: PageCaptureLimit, captureNum: parsedProps.captureTrgts })
        const captureInfo = (() => {
          if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
          return {}
        })()

        if (captureInfo && Boolean(captureInfo.violationID)) {
          const hasUpdated = await runViolationUpdate(status, [captureInfo.violationID])
          if (!hasUpdated) {
            Toast.fire({
              icon: 'error',
              title: 'Failed to update violation!'
            })
          } else {
            Toast.fire({
              icon: 'success',
              title: 'Violation updated successfully!'
            })

            // determine whether to include the violation in the violationIDs array
            if (Filter.captureAreas.length > 0) {
              const violationIDs = [...Filter.includeViolationIDs]
              const idx = violationIDs.indexOf(captureInfo.violationID)
              const includeViolation = idx === -1
              if (includeViolation) { violationIDs.push(captureInfo.violationID) }
              refreshCapturesRef.current = false
              dispatch(setFilter({ ...Filter, includeViolationIDs: violationIDs, refresh: false }))
            } else {
              refreshCapturesRef.current = false
              dispatch(setFilter({ ...Filter, includeViolationIDs: [], refresh: false }))
            }

            // if there is only one capture left and we're on the last page, push to default view
            if (
              (typeof parsedProps.captureTrgts === 'number' && parsedProps.captureTrgts && typeof Hits === 'number' && parsedProps.captureTrgts >= Hits) ||
              (fromLink && typeof captureIx === 'number' && Boolean(Captures.length) && captureIx >= Captures.length)
            ) {
              Toast.fire({
                icon: 'success',
                title: 'You have reached the end of this capture list.'
              })
              if (DefaultView === 'L') {
                return props.history.push({
                  pathname: '/captures',
                  search: '?view=list&page=1&activeCapture=0'
                })
              } else if (DefaultView === 'G') {
                return props.history.push({
                  pathname: '/captures',
                  search: '?view=grid&page=1&activeCaptures=[]'
                })
              } else if (DefaultView === 'D') {
                return props.history.push({
                  pathname: '/captures',
                  search: '?view=single&capture=1'
                })
              } else {
                return props.history.push({
                  pathname: '/captures',
                  search: '?view=grid&page=1&activeCaptures=[]'
                })
              }
            }
          }
          if (AwaitTrigger && hasUpdated) {
            dispatch(setTriggerFilter(true))
          }

          // Redirects in the event there is more than one capture
          if (pageType === null && Captures.length !== 1) {
            props.history.push({
              pathname: '/captures',
              search: `?view=single&capture=${parsedProps.captureTrgts + 1}`
            })
          } else if (pageType !== null) {
            if (pageType === 'list') {
              props.history.push({
                pathname: '/captures',
                search: `?view=${pageType}&page=${parsedProps.page}&activeCapture=0`
              })
            } else if (pageType === 'grid') {
              dispatch(setAllChecked(false))
              props.history.push({
                pathname: '/captures',
                search: `?view=${pageType}&page=${parsedProps.page}&activeCaptures=[]`
              })
            } else if (pageType === 'next') {
              props.history.push({
                pathname: '/captures',
                search: `?view=single&capture=${parsedProps.captureTrgts + 1}`
              })
            } else if (pageType === 'prev') {
              props.history.push({
                pathname: '/captures',
                search: `?view=single&capture=${parsedProps.captureTrgts - 1}`
              })
            } else if (pageType === 'dashboard') {
              props.history.push('/dashboard')
            } else if (pageType === 'reports') {
              props.history.push('/reports')
            } else if (pageType === 'advanced-filter') {
              toggleFilterModal()
            } else if (pageType === 'search-view') {
              setSearchOpen(true)
            } else if (pageType === 'back') {
              props.history.push({
                pathname: '/captures',
                search: `?view=single&capture=${parsedProps.captureTrgts - 1}`
              })
            } else if (pageType === 'captures') {
              if (DefaultView === 'L') {
                props.history.push({
                  pathname: '/captures',
                  search: '?view=list&page=1&activeCapture=0'
                })
              } else if (DefaultView === 'G') {
                props.history.push({
                  pathname: '/captures',
                  search: '?view=grid&page=1&activeCaptures=[]'
                })
              } else if (DefaultView === 'D') {
                props.history.push({
                  pathname: '/captures',
                  search: '?view=single&capture=1'
                })
              }
            }
            dispatch(setPageType(null))
          }
        }
        break
      }
      case 'list': {
        const captureIx = getViolationIndex({ page: parsedProps.page, currentView: parsedProps.view, pageLimit: PageCaptureLimit, captureNum: parsedProps.captureTrgts })
        const captureInfo = (() => {
          if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
          return {}
        })()

        if (captureInfo && Boolean(captureInfo.violationID)) {
          const hasUpdated = await runViolationUpdate(status, [captureInfo.violationID])
          if (!hasUpdated) {
            Toast.fire({
              icon: 'error',
              title: 'There was an error updating the selected Violation(s). Please try again.'
            })
          } else {
            Toast.fire({
              icon: 'success',
              title: 'Violation(s) updated successfully.'
            })
          }

          if (Filter.captureAreas.length > 0) {
            const violationIDs = [...Filter.includeViolationIDs]
            const idx = violationIDs.indexOf(captureInfo.violationID)
            const includeViolation = idx === -1

            if (includeViolation) { violationIDs.push(captureInfo.violationID) }

            refreshCapturesRef.current = false
            dispatch(setFilter({ ...Filter, includeViolationIDs: violationIDs, refresh: false }))

            // By now it should exist since captureInfo needs to be defined
            if (Captures[parsedProps.captureTrgts + 1]) {
              dispatch(setAllChecked(false))
                .then(
                  props.history.push({
                    pathname: '/captures',
                    search: `?view=list&page=${parsedProps.page}&activeCapture=${parsedProps.captureTrgts}`
                  })
                )
            } else if (Captures[captureIx + 1] && Captures[parsedProps.captureTrgts + 1]) {
              dispatch(setAllChecked(false))
                .then(
                  props.history.push({
                    pathname: '/captures',
                    search: `?view=list&page=${parsedProps.page + 1}&activeCapture=0`
                  })
                )
            }

            // if there is only one capture left and we're on the last page, push to default view
            if (
              (typeof parsedProps.captureTrgts === 'number' && typeof Hits === 'number' && parsedProps.captureTrgts >= Hits) ||
              (fromLink && typeof parsedProps.captureTrgts === 'number' && parsedProps.captureTrgts >= Captures.length)
            ) {
              Toast.fire({
                icon: 'info',
                title: `No more captures available with the status '${statusName}'.`
              })
            }
          } else {
            refreshCapturesRef.current = false
            dispatch(setFilter({ ...Filter, includeViolationIDs: [], refresh: false }))

            if (Captures[parsedProps.captureTrgts + 1]) {
              dispatch(setAllChecked(false))
                .then(
                  props.history.push({
                    pathname: '/captures',
                    search: `?view=list&page=${parsedProps.page}&activeCapture=${parsedProps.captureTrgts + 1}`
                  })
                )
            } else if (Captures[captureIx + 1] && !Captures[parsedProps.captureTrgts + 1]) {
              dispatch(setAllChecked(false))
                .then(
                  props.history.push({
                    pathname: '/captures',
                    search: `?view=list&page=${parsedProps.page + 1}&activeCapture=0`
                  })
                )
            }

            // if there is only one capture left and we're on the last page, push to default view
            if (
              (typeof parsedProps.captureTrgts === 'number' && typeof Hits === 'number' && parsedProps.captureTrgts >= Hits) ||
              (fromLink && typeof parsedProps.captureTrgts === 'number' && parsedProps.captureTrgts >= Captures.length)
            ) {
              const filter = { ...Filter, captureAreas: Status, refresh: true }
              dispatch(setFilter(filter))
              Toast.fire({
                icon: 'info',
                title: `No more captures available with the status '${statusName}'.`
              })
            }
          }
          break
        } else {
          console.error('Could not find any selected captures.')
          break
        }
      }
      default: break
    }
  }

  const runViolationUpdate = async (status, violations) => {
    // Dispatch for actual status udpate
    const hasUpdated = await dispatch(setViolationStatus(violations, status))

    if (!hasUpdated) return false

    // updateHistory(status, violations)

    // Modifies Capture UI to reflect status changes
    const tempCaptures = [...Captures]
    violations.forEach((id) => {
      const idx = tempCaptures.findIndex((capture) => capture.violationID === id)
      tempCaptures[idx].statusFlag = status
    })
    dispatch(setViolations(tempCaptures))

    dispatch(setAllChecked(false))
    dispatch(setCaptureSelections([]))

    if (parsedProps.view === 'single') { dispatch(getHistory(violations)) }

    return true
  }

  const getViolationInfo = () => {
    if (parsedProps.view !== 'grid' && typeof parsedProps.captureTrgts === 'number') {
      const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageCaptureLimit, page: parsedProps.page, currentView: parsedProps.view })
      const captureInfo = (() => {
        if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
        return {}
      })()

      if (captureInfo && Boolean(captureInfo.violationID)) { return [captureInfo] }
    }

    if (parsedProps.view === 'grid' && Array.isArray(parsedProps.captureTrgts) && Boolean(parsedProps.captureTrgts.length)) {
      const activeViolations = parsedProps.captureTrgts.reduce((arr, captureNum) => {
        const captureIx = getViolationIndex({ captureNum, pageLimit: PageCaptureLimit, page: parsedProps.page, currentView: parsedProps.view })
        const captureInfo = (() => {
          if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
          return {}
        })()

        if (captureInfo && Boolean(captureInfo.violationID)) {
          arr.push({ ...captureInfo })
        }

        return arr
      }, [])

      return activeViolations
    }

    return []
  }

  const shareClick = () => {
    const activeViolations = getViolationInfo()

    // Create array of unique status codes from active violations to share
    const violationStatuses = activeViolations?.length ? [...new Set(activeViolations.map((violation) => violation.statusFlag))] : null

    switch (parsedProps.view) {
      case 'grid': {
        if (Array.isArray(parsedProps.captureTrgts) && Boolean(parsedProps.captureTrgts.length)) {
          const captureUnits = parsedProps.captureTrgts.reduce((arr, captureNum) => {
            if (typeof captureNum === 'number') {
              const captureIx = getViolationIndex({ page: parsedProps.page, currentView: parsedProps.view, pageLimit: PageCaptureLimit, captureNum })
              const captureInfo = (() => {
                if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
                return {}
              })()

              if (captureInfo && Boolean(captureInfo.violationID)) {
                const [unitInfo] = captureInfo.units.slice(-1)

                if (unitInfo && Boolean(unitInfo.unitID)) { arr.push(unitInfo.unitID) }
              }
            }
            return arr
          }, [])

          if (captureUnits.length) {
            dispatch(getAvailableUsers(captureUnits, violationStatuses))
            dispatch(setShareModal(true))
          } else {
            Toast.fire({
              icon: 'info',
              title: 'Please select one or more captures.'
            })
          }
        } else {
          Toast.fire({
            icon: 'info',
            title: 'Please select one or more captures.'
          })
        }

        break
      }
      case 'single':
      case 'list': {
        const captureIx = getViolationIndex({ page: parsedProps.page, currentView: parsedProps.view, pageLimit: PageCaptureLimit, captureNum: parsedProps.captureTrgts })
        const captureInfo = (() => {
          if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
          return {}
        })()

        if (captureInfo && Boolean(captureInfo.violationID)) {
          const [unitInfo] = captureInfo.units.slice(-1)

          if (unitInfo && Boolean(unitInfo.unitID)) {
            dispatch(getAvailableUsers([unitInfo.unitID], violationStatuses))
            // dispatch(setCaptureSelection([violation.violationID]))
            dispatch(setShareModal(true))
          }
        } else {
          Toast.fire({
            icon: 'info',
            title: 'Please select one or more captures.'
          })
        }

        break
      }
      default: break
    }
  }

  const handleUnitChange = async (selectedUnits) => {
    // updates captures to only display those associated with the units the user has selected
    // units are only applied to the filter if the user has permission to view them
    if (selectedUnits && selectedUnits.length && TreeData.length) {
      const AssignedUnits = keyify2(TreeData[0].children)

      const targetUnits = selectedUnits.filter((unit) => AssignedUnits.includes(unit))
      let newfilter = { ...Filter, violationIDs: [], includeViolationIDs: [], refresh: true }
      // JJC having to get weird with the array here because it won't let me set it equal to another array
      newfilter.units.length = 0
      newfilter.units.push(...targetUnits)

      dispatch(setFilter(newfilter))
      dispatch(setMySchoolsModal(false))
      newfilter = null
    } else {
      console.error('No units selected!')
      Toast.fire({
        icon: 'info',
        title: 'Please select one or more units.'
      })
    }
  }

  const handlePrint = () => {
    switch (parsedProps.view) {
      case 'list':
      case 'single': {
        const captureIx = getViolationIndex({ page: parsedProps.page, currentView: parsedProps.view, pageLimit: PageCaptureLimit, captureNum: parsedProps.captureTrgts })
        const captureInfo = (() => {
          if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
          return {}
        })()

        if (captureInfo && Boolean(captureInfo.violationID)) {
          dispatch(setPrintCaptures([captureInfo]))
          dispatch(setPrinterModal(true))

          dispatch(getComments([captureInfo.violationID]))
          dispatch(getHistory([captureInfo.violationID]))
        } else {
          Toast.fire({
            icon: 'info',
            title: 'Please select one or more captures.'
          })
        }

        break
      }
      case 'grid': {
        const currentCaptures = parsedProps.captureTrgts.reduce((arr, captureNum) => {
          if (typeof captureNum === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) {
            const captureIx = getViolationIndex({ page: parsedProps.page, currentView: parsedProps.view, pageLimit: PageCaptureLimit, captureNum })
            const captureInfo = (() => {
              if (typeof captureIx === 'number' && Array.isArray(Captures) && Boolean(Captures.length)) { return Captures[captureIx] }
              return {}
            })()

            if (captureInfo && Boolean(captureInfo.violationID)) { arr.push({ ...captureInfo }) }
          }
          return arr
        }, [])

        if (currentCaptures.length) {
          dispatch(setPrintCaptures(currentCaptures))
          dispatch(setPrinterModal(true))

          const mappedCaptures = currentCaptures.map((capture) => capture.violationID)
          dispatch(getComments(mappedCaptures))
          dispatch(getHistory(mappedCaptures))
        } else {
          Toast.fire({
            icon: 'info',
            title: 'Please select one or more captures.'
          })
        }

        break
      }
      default: break
    }
  }

  const handleExport = () => {
    dispatch(setExportModal(true))
  }

  const [tourOpen, setTourOpen] = useState(false)
  const toggleTourOpen = useCallback(() => {
    setTourOpen(!tourOpen)
  }, [tourOpen])

  const localTourItem = 'viewedFilterTour'

  useMemo(() => {
    const viewed = window.localStorage.getItem(localTourItem)

    if (!viewed && !tourOpen) {
      toggleTourOpen()
    }
  }, [toggleTourOpen, tourOpen])

  return (
    <>
      <iframe
        id='capturePrint'
        style={{ display: 'none' }}
        title='Print Captures'
      />
      <NavbarComponent
        handleSchoolsToggle={async () => dispatch(setMySchoolsModal(true))}
        handleSettingsToggle={async () => dispatch(setSettingsModal(true))}
        currentView={parsedProps.view}
        SelectedStatus={SelectedStatus}
        setSelectedStatus={setSelectedStatus}
        fromLink={fromLink}
      />
      {/* Start of Modals */}
      <ReportsModal
        toggleModal={async () => dispatch(setReportsModal(false))}
        open={ReportsModalState}
      />
      <SettingsScreen
        toggleModal={async () => dispatch(setSettingsModal(false))}
        open={SettingsModal}
      />
      <PrintCapturesPreview
        captures={PrintCaptures}
        toggleModal={async () => dispatch(setPrinterModal(false))}
        open={PrinterModal}
        fromLink={fromLink}
      />
      <ExportCaptures
        toggleModal={async () => dispatch(setExportModal(false))}
        open={ExportModal}
      />
      <ShareCard
        onShare={handleShare}
        open={ShareModal}
        handleClickStatus={clickStatus}
        toggleModal={async () => dispatch(setShareModal(false))}
        handleGetViolationInfo={getViolationInfo}
      />
      <SearchResultsUI
        onFilter={handleSearchSelection}
        open={SearchModal}
        currentView={parsedProps.view}
        setSearchOpen={setSearchOpen}
        fromLink={fromLink}
        setSelectedStatus={setSelectedStatus}
      />
      <FilterSlideout
        open={FilterModal}
        formData={Filter}
        fromLink={fromLink}
        toggleTourOpen={toggleTourOpen}
      />
      <FilterTour
        toggleTourOpen={toggleTourOpen}
        tourOpen={tourOpen}
        localTourItem={localTourItem}
      />
      <MySchoolsModal
        onSave={(selectedKeys) => handleUnitChange(selectedKeys)}
        toggleModal={async () => dispatch(setMySchoolsModal(false))}
        open={SchoolsModal}
        treeData={TreeData}
        selectedUnits={Filter.units}
        fromLink={fromLink}
      />
      {/* End of Modals */}
      <>
        <Grid
          container
          direction='row'
          style={{
            // width: 'fit-content',
            // width: 'auto',
            width: '10rem',
            position: 'fixed',
            left: '2vw',
            top: currentPath === 'reports' ? '9.45rem' : '25vh',
            height: currentPath === 'reports' ? '' : '75vh',
            // minWidth: '10em',
            // minHeight: '40em',
            zIndex: '1050'
          }}
        >
          <Grid item container direction='column' spacing={3} className='my-auto h-100'>

            {
              currentPath === 'reports'
                ? (
                  <Grid
                    item
                    container
                    direction='row'
                    justify='center'
                    className='mb-auto'
                  >
                    <ReportsButtonContainer fromLink={fromLink} />
                  </Grid>)
                : (
                  <>
                    <Grid
                      item
                      container
                      direction='row'
                      justify='center'
                      style={{ visibility: currentPath === 'dashboard' ? 'hidden' : 'visible' }}
                      className='mt-auto'
                    >
                      <Flagger />
                    </Grid>

                    <Grid
                      item
                      container
                      direction='row'
                      justify='center'
                      className='mb-auto'
                      style={{ visibility: currentPath === 'dashboard' ? 'hidden' : 'visible' }}
                    >
                      <InteractiveButton
                        handleClickStatus={clickStatus}
                        handleShareClick={shareClick}
                        captureDetailModal={CaptureModal}
                        fromLink={fromLink}
                      />
                    </Grid>
                  </>)
            }

            <Grid item container direction='row' justify='center' className='mb-auto'>
              <NavButtonContainer
                toggleSettingsModal={async () => dispatch(setSettingsModal(true))}
                toggleFilterModal={async () => toggleFilterModal()}
                toggleReportsModal={async () => dispatch(setReportsModal(true))}
                snackShow={SnackShow}
                currentView={parsedProps.view}
                fromLink={fromLink}
              />
            </Grid>
          </Grid>
        </Grid>

        {
          currentPath === 'dashboard' || currentPath === 'reports'
            ? (<></>)
            : (
              <TablePagination
                onSort={handleSort}
                onRefresh={handleRefresh}
                onPrint={handlePrint}
                onExport={handleExport}
                onSearch={handleSearch}
                currentView={parsedProps.view}
                snackShow={SnackShow}
                SelectedStatus={SelectedStatus}
                setSelectedStatus={setSelectedStatus}
                searchOpen={searchOpen}
                setSearchOpen={setSearchOpen}
                fromLink={fromLink}
                toggleFilterModal={async () => toggleFilterModal()}
              />)
        }

        <ElevioIntegration
          keywords={
            SettingsModal
              ? ['Settings']
              : currentPath === 'dashboard'
                ? ['Dashboard']
                : currentPath === 'captures'
                  ? ['Capture']
                  : currentPath === 'reports'
                    ? ['Reports']
                    : null
          }
        />
      </>
    </>
  )
}

export default withRouter(CapturePageBody)
